import Card, { CardContent } from '@cobliteam/ui/components/Card';
import Skeleton from '@cobliteam/ui/components/Skeleton';

const StepCardSkeleton = () => (
  <Card>
    <CardContent className='flex flex-row items-center gap-4'>
      <Skeleton className='size-5 rounded' />
      <div className='flex flex-row items-center gap-2'>
        <Skeleton className='h-5 w-32' />
        <Skeleton className='size-4 rounded-full' />
      </div>
      <Skeleton className='ml-auto size-8 rounded' />
    </CardContent>
  </Card>
);

const CategoryAccordionSkeleton = () => (
  <div className='flex flex-col gap-2'>
    <div className='flex flex-col gap-2 rounded-md border border-gray-6 p-4'>
      <div className='flex flex-row items-center gap-2'>
        <Skeleton className='h-5 w-40' />
        <Skeleton className='h-5 w-12 rounded-full' />
      </div>
      <Skeleton className='h-4 w-64' />
    </div>
    <div className='flex flex-col gap-2 pl-4'>
      <StepCardSkeleton />
      <StepCardSkeleton />
      <StepCardSkeleton />
    </div>
  </div>
);

const OnboardingChecklistSkeleton = () => {
  return (
    <div className='flex max-h-[50vh] w-[38rem] flex-col overflow-hidden'>
      {/* Fixed header section */}
      <div className='-mx-4 flex flex-shrink-0 flex-col gap-1 border-gray-6 border-b px-4 pb-4'>
        <Skeleton className='h-6 w-48' />
        <div className='mb-4 flex flex-col gap-1'>
          <Skeleton className='h-4 w-3/4' />
        </div>
      </div>

      {/* Scrollable steps section */}
      <div className='w-full flex-1 overflow-y-auto p-4'>
        <div className='flex flex-col gap-2'>
          <CategoryAccordionSkeleton />
          <CategoryAccordionSkeleton />
        </div>
      </div>
    </div>
  );
};

export default OnboardingChecklistSkeleton;
